angular.module('impactx.controlstructure').controller('BasketControlStructureInputCtrl', [
    '$mdPanel',
    'TranslationService',
    '$timeout',
    'BasketAdHocControlStructureService',
    '$mdDialog',
    'AppConfiguration',
    BasketControlStructureInputController
]);

function BasketControlStructureInputController($mdPanel, TranslationService, $timeout, BasketAdHocControlStructureService, $mdDialog, AppConfiguration) {
    var self = this;
    self.$onInit = function () {
        self.inputFieldName = self.name + self.data.identifier + 'Input';
    };
    self.hasInvalidFactors = false;
    self.controlSelectionIsShown = false;

    self.showDistribButton = AppConfiguration.get('showDistributeAccountingButton');
    self.autoDistrib = AppConfiguration.get('enableAutoAccountingDistribution');
    self.useHelperDialog = AppConfiguration.get('useAccountingHelper');
    self.factorLabel = TranslationService.get('controlPercentInput');

    self.openNewControlPanel = function (event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        BasketAdHocControlStructureService.openPanel(event, self.data, self.trns, closePanel);
    };

    self.toggleControlSelection = function () {
        self.controlSelectionIsShown = !self.controlSelectionIsShown;
        if (self.controlSelectionIsShown) {
            focusAutocomplete();
        }
    };

    self.querySearch = function (query) {
        return query ? self.data.allowed.entries.filter(createFilterFor(query)) : self.data.allowed.entries;
    };


    self.checkFactors = function () {
        if (self.data.set && self.data.set.length > 1) {
            var total = 0;
            for (var i = 0; i < self.data.set.length; i++) {
                total += self.data.set[i].factor * 100;
            }
            var hasInvalidFactors = total !== 100;
            self.hasInvalidFactors = hasInvalidFactors;
            self.formCtrl[self.inputFieldName].$setValidity("invalidFactors", !hasInvalidFactors);
        }
        else {
            self.hasInvalidFactors = false;
            self.formCtrl[self.inputFieldName].$setValidity("invalidFactors", true);
        }
    };

    self.addControlStructure = function (newControl) {
        if (newControl) {
            self.searchText = "";
            self.selectedItem = undefined;

            var setCtrls = self.data.set.filter(function (obj) {
                return obj.id === newControl.id;
            });
            if (setCtrls.length === 0) {
                newControl.factor = 1;
                if(!self.useHelperDialog && self.data.set.length >= 1 && !self.autoDistrib)
                {
                    newcontrol.factor = 0;
                }
                if (self.data.maxNumber && self.data.maxNumber > 0 && self.data.maxNumber <= self.data.set.length) {
                    self.data.set.splice(self.data.maxNumber - 1, self.data.set.length);
                    self.data.set[self.data.maxNumber ? self.data.maxNumber - 1 : 0] = newControl;
                }
                else {
                    self.data.set.push(newControl);
                }

                self.toggleControlSelection();
                if (self.autoDistrib) {
                    self.setEqualDistribution();
                }
                else {
                    self.checkFactors();
                }
                if(self.useHelperDialog && self.data.set.length > 1) {
                    self.openHelperDialog();
                }
            }
        }
    };

    self.removeControlStructure = function (controlStructure) {
        var indexOf = self.data.set.indexOf(controlStructure);
        if (indexOf >= 0) {
            self.data.set.splice(indexOf, 1);
            self.checkFactors();
        }
    };

    self.setEqualDistribution = function (buttonPress) {
        if (buttonPress || self.autoDistrib) {
            var fracSize = self.fractionSize || 2;
            var distribution = self.data.set;
            var length = distribution.length;
            var equal = Math.round((Math.pow(10, 2) / length) * Math.pow(10, fracSize)) / Math.pow(10, fracSize+2);
            var total = 0;
            for (var i = 0; i < length - 1; i++) {
                distribution[i].factor = equal;
                total = total + equal;
            }
            distribution[i].factor = Math.round((100 - total*100) * Math.pow(10, fracSize)) / Math.pow(10, fracSize+2);
            self.hasInvalidFactors = false;
            self.formCtrl[self.inputFieldName].$setValidity("invalidFactors", true);
        }
        else {
            self.checkFactors();
        }
    };
    
    self.openHelperDialog = function (event) {
        if(self.helperDialogParams) {
            $mdDialog.show({
                controller: 'AccountingHelperCtrl',
                controllerAs: 'helperCtrl',
                templateUrl: 'modules/control/templates/basket-control-structure-helper.dialog.html',
                targetEvent: event,
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                locals: {
                    params: self.helperDialogParams,
                    current: self.data.set
                }
            }).then(function(answer) {
                self.data.set = answer;
                self.checkFactors();
            })
        }
    };

    function closePanel(panelRef, newControl) {
        if (newControl) {
            self.data.allowed.entries.push(newControl);
            self.addControlStructure(newControl);
            if (self.saveBasket && impactX.isFunc(self.saveBasket)) {
                self.saveBasket();
            }
        }
    }

    function focusAutocomplete() {
        $timeout(function () {
            angular.element('#' + self.data.identifier + 'Autocomplete').focus();
        }, 100);
    }

    self.formatItemText = function (entry) {
        if (entry.name) {
            return entry.value + ' ' + entry.name;
        } else {
            return entry.value;
        }
    };

    function createFilterFor(query) {
        var lowercaseQuery = query.toLowerCase();

        return function filterFn(controlStructure) {
            var lowerCaseControlStructureName = self.formatItemText(controlStructure).toLowerCase();
            return (lowerCaseControlStructureName.indexOf(lowercaseQuery) >= 0);
        };
    }
}